<template >
  <div class="classDialog">
    <el-dialog
      title="新增关联"
      :visible.sync="classDialogVisible"
      width="650px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="mapForm"
        :model="mapForm"
        :rules="rules"
        label-width="60px"
      >
        <el-select
          v-model="mapForm.stageId"
          placeholder="请选择学段"
          @change="changeStage"
          style="width: 120px"
        >
          <el-option
            v-for="item in pStages"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="mapForm.gradeId"
          placeholder="请选择年级"
          @change="changeGrade"
          style="width: 220px"
          multiple
        >
          <el-option
            v-for="item in grades"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="mapForm.oldPaperTypeId"
          placeholder="请选择类型"
          multiple
          style="width: 261px"
        >
          <el-option
            v-for="item in oldTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div style="height: 20px;width: 100%"></div>
        <el-form-item
          label="关键字"
          prop="keyword"
        >
          <el-input
            v-model="mapForm.keyword"
            placeholder="请输入关键字, 多个关键词以,分割"
            :maxlength="200"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="排除项"
          prop="excludeKeyword"
        >
          <el-input
            v-model="mapForm.excludeKeyword"
            placeholder="请输入排除项, 多个排除项以,分割"
            :maxlength="200"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">

import { tagMixins } from "../mixins/tagMixins";
export default {
  mixins: [tagMixins],
  props: {
    pStages: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      mapForm: {
        id: '',
        stageId: '',
        gradeId: [],
        oldPaperTypeId: [],
        columnId: '',
        newPaperTypeId: '',
        keyword: '',
        excludeKeyword: ''
      },
      rules: {
        stageId: [
          {required: true, message: '学段不能为空', trigger: ['blur', 'change']}
        ],
        columnId: [
          {required: true, message: '栏目不能为空', trigger: ['blur', 'change']}
        ],
        newPaperTypeId: [
          {required: true, message: '新类型不能为空', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    save() {
      this.$refs.mapForm.validate(async valid => {
        if (valid) {
          this.$emit('success', this.mapForm)
        }
      });
    },
    changeStage() {
      this.getGrade();
    },
    changeGrade() {
      this.getOldType();
    }
  },
  watch: {
    async classDialogVisible (newVal, oldVal) {
      if (newVal) {
        this.stageId = this.$props.rowData.stageId;
        await this.getGrade();
        await this.getOldType();
        this.mapForm = {
          ...this.mapForm,
          ...this.$props.rowData
        }
        console.log(this.mapForm);
      }
    }
  },
  computed: {
    classDialogVisible: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>
<style scoped>
  .classDialog .el-select{
    width: 30%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/shijuan-manage/edit-dialog/map.vue